import axios from "axios";
import { reviewDataAction } from "../redux/action";
import { serverUrl } from "../../ApiUrl";

export const reviewDataGet = (dispatch) =>{
    axios.get(`${serverUrl.u}/api/faq/getReview`).then(
        function (response) {
            const {message,data,success} = response.data
            dispatch(reviewDataAction(data))
        }
    ).catch(function (error) {
        console.log(error);
    })
}